import {
  Stack as ChakraStack,
  HStack as ChakraHStack,
  VStack as ChakraVStack,
  type StackProps as ChakraStackProps
} from "@chakra-ui/react";
import {
  forwardRef,
  type ElementType,
  type FormHTMLAttributes,
  type Ref
} from "react";

type PolymorphicHtmlProps = {
  noValidate?: boolean;
  method?: string;
  action?: string;
  acceptCharset?: string;
  encType?: string;
  htmlFor?: string;
  href?: string;
  target?: string;
  rel?: string;
  type?: string;
  name?: string;
  autoComplete?: string;
  tabIndex?: number;
  disabled?: boolean;
  outline?: string;
  onSubmit?: FormHTMLAttributes<HTMLElement>["onSubmit"];
  placeholder?: string;
  defaultValue?: string;
};

export type StackProps = ChakraStackProps &
  Partial<PolymorphicHtmlProps> & {
    as?: ElementType;
    ref?: Ref<HTMLDivElement>;
  };

export const Stack = forwardRef<HTMLDivElement, StackProps>(
  function Stack(props, ref) {
    return <ChakraStack ref={ref} {...(props as ChakraStackProps)} />;
  }
);

export const HStack = forwardRef<HTMLDivElement, StackProps>(
  function HStack(props, ref) {
    return <ChakraHStack ref={ref} {...(props as ChakraStackProps)} />;
  }
);

export const VStack = forwardRef<HTMLDivElement, StackProps>(
  function VStack(props, ref) {
    return <ChakraVStack ref={ref} {...(props as ChakraStackProps)} />;
  }
);
